var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"not-found"},[_c('h1',[_vm._v("404 - Not Found")])])
}
var staticRenderFns = []

export { render, staticRenderFns }